import { render } from "./employee-assets.vue?vue&type=template&id=5742b35d"
import script from "./employee-assets.vue?vue&type=script&lang=js"
export * from "./employee-assets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__